export default "__VITE_ASSET__BtKuRFNc__"